/**
 * CLOUD_EDGE_FADE_MASK — horizontal mask that fades a cloud layer out near the
 * left/right edges of the phone-width column (B1). Clouds dissolve softly into
 * the sky at the phone-frame boundary instead of a hard clip or spilling into
 * the empty desktop gutters. Apply to the clouds layer only (NOT the sun).
 */
import { CSSProperties } from "react";

// Long, gradual fade band: clouds dissolve smoothly to nothing over the outer
// ~18% of each side rather than getting clipped at a hard line near the edge.
// The linear ramp from transparent (very edge) to opaque (18%) means a cloud
// straddling the column edge thins out gradually instead of cutting off.
const fade =
  "linear-gradient(to right, transparent 0%, #000 18%, #000 82%, transparent 100%)";

export const CLOUD_EDGE_FADE_MASK: CSSProperties = {
  WebkitMaskImage: fade,
  maskImage: fade,
  WebkitMaskRepeat: "no-repeat",
  maskRepeat: "no-repeat",
  WebkitMaskSize: "100% 100%",
  maskSize: "100% 100%",
};
